export const CHROMA_COLLECTION_REQUEST = "CHROMA_COLLECTION_REQUEST";
export const CHROMA_COLLECTION_SUCCESS = "CHROMA_COLLECTION_SUCCESS";
export const CHROMA_COLLECTION_FAILED = "CHROMA_COLLECTION_FAILED";
